export default "__VITE_PUBLIC_ASSET__c488c4be__"